import React from 'react';
import { Route as RRRoute, Redirect } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
const Route = inject('store')(observer((props) => {
    const { component, path, exact, auth, render, store } = props;
    /*console.log('component', component)
    console.log('path', path)
    console.log('exact', exact)
    console.log('auth', auth)
    console.log('render', render)
    console.log('store', store)*/
    if (!store)
        return null;
    if ((auth === true && store.users.user === undefined) ||
        (typeof auth === 'string' && store.users.user.role !== auth) ||
        (auth instanceof Array && auth.includes(store.users.user.role)))
        return React.createElement(Redirect, { to: "/login" });
    return React.createElement(RRRoute, Object.assign({}, { component, path, exact, auth, render }));
}));
export default Route;



//////////////////
// WEBPACK FOOTER
// ./src/components/Route.tsx
// module id = 548
// module chunks = 0